module.exports = __webpack_public_path__ + "static/CGV_2022-097df9e06eca95ef4e7a7e2e5638cf5a.pdf";